module.exports = __webpack_public_path__ + "img/2.0e10d0c4.png";